import { ViewConfigInterface } from "../../viewConfig.types";
import { validators } from "react-ocean-forms";
import { Permissions } from "../../../Permissions";
import { customvalidators } from "../../../utils";


export const readViewRequestForm: ViewConfigInterface = {
  email: { 
    field: {
      disabled: true,
      hidden: false,
      plaintext: true,
    },
    permissions: [Permissions.RequestInfoEmailView]
  },
  zweckOderQuelle: {
    field: {
      disabled: true,
      hidden: false,
      plaintext: true,
      //@ts-ignore
      validators: [validators.withParam(validators.maxLength, 400)],
    },
    permissions: [Permissions.RequestInfoSourceView]
  },
  anmerkung: {
    field: {
      disabled: true,
      hidden: false,
      plaintext: true,
      //@ts-ignore
      validators: [validators.withParam(validators.maxLength, 1000)],
    },
    permissions: [Permissions.RequestInfoAnnotation]
  }
}

export const editViewRequestForm: ViewConfigInterface = {
  email: {
    field: {
      disabled: false,
      hidden: false,
      plaintext: false,
      validators: [validators.required, customvalidators.email],
    },
    permissions: [Permissions.RequestInfoEmailEdit]
  },
  zweckOderQuelle: {
    field: {
      disabled: false,
      hidden: false,
      plaintext: false,
      //@ts-ignore
      validators: [validators.required, validators.withParam(validators.maxLength, 400)],
    },
    permissions: [Permissions.RequestInfoSourceEdit]
  },
  anmerkung: {
    field: {
      disabled: false,
      hidden: false,
      plaintext: false,
      //@ts-ignore
      validators: [validators.withParam(validators.maxLength, 1000)],
    },
    permissions: [Permissions.RequestInfoAnnotation]
  },
}

export const newViewRequestForm: ViewConfigInterface = {
  email: {
    field: {
      disabled: false,
      hidden: false,
      plaintext: false,
      validators: [validators.required, customvalidators.email],
    },
    permissions: [Permissions.RequestInfoEmailNew]
  },
  zweckOderQuelle: {
    field: {
      disabled: false,
      hidden: false,
      plaintext: false,
      //@ts-ignore
      validators: [validators.required, validators.withParam(validators.maxLength, 400)],
    },
    permissions: [Permissions.RequestInfoSourceNew]
  },
  anmerkung: {
    field: {
      disabled: false,
      hidden: false,
      plaintext: false,
      //@ts-ignore
      validators: [validators.withParam(validators.maxLength, 1000)],
    },
    permissions: [Permissions.RequestInfoAnnotation]
  },
}


export const deleteViewRequestForm: ViewConfigInterface = {
  email: {
    field: {
      disabled: true,
      hidden: false,
      plaintext: false,
    },
    permissions: [Permissions.RequestInfoEmailDelete]
  },
  zweckOderQuelle: {
    field: {
      disabled: true,
      hidden: false,
      plaintext: false,
      //@ts-ignore
      validators: [validators.withParam(validators.maxLength, 400)],
    },
    permissions: [Permissions.RequestInfoSourceDelete]
  },
  anmerkung: {
    field: {
      disabled: false,
      hidden: false,
      plaintext: false,
      //@ts-ignore
      validators: [validators.required, validators.withParam(validators.maxLength, 1000)],
    },
    permissions: [Permissions.RequestInfoAnnotation]
  },
}

export const searchViewRequestForm: ViewConfigInterface = {
  email: {
    field: {
      disabled: true,
      hidden: false,
      plaintext: false,
    },
  },
  zweckOderQuelle: {
    field: {
      disabled: true,
      hidden: false,
      plaintext: false,
      //@ts-ignore
      validators: [validators.withParam(validators.maxLength, 400)],
    },
  },
  anmerkung: {
    field: {
      disabled: false,
      hidden: false,
      plaintext: false,
      //@ts-ignore
      validators: [validators.withParam(validators.maxLength, 1000)],
    },
  },
}
